import React from 'react';
import PropTypes from 'prop-types';
import { Box, IconButton } from '@material-ui/core';
import CloseIcon from '@mui/icons-material/Close';
import { Typography } from '@orijinworks/frontend-commons';
import {
  formatResidentMetaLine,
  getResidentDisplayName,
  getResidentInitials,
} from '../../../../utils/case-plan-create.util';
import { useSelectedResidentCardStyles } from './SelectedResidentCard.styles';

/**
 * Selected resident row: avatar initials, name, meta line, and remove action.
 * Matches Figma Selected Resident (967:21460). Use compact in the 2-column grid.
 */
export const SelectedResidentCard = ({ resident, onRemove, compact }) => {
  const classes = useSelectedResidentCardStyles();
  const displayName = getResidentDisplayName(resident);
  const initials = getResidentInitials(displayName || resident.username);
  const metaLine = formatResidentMetaLine(resident);
  const rootClassName = compact
    ? `${classes.root} ${classes.rootCompact}`
    : classes.root;

  return (
    <Box className={rootClassName}>
      <Box className={classes.content}>
        <Box className={classes.avatar} aria-hidden>
          <Typography className={classes.initials}>{initials}</Typography>
        </Box>
        <Box className={classes.copy}>
          <Typography className={classes.name}>{displayName}</Typography>
          <Typography className={classes.meta}>{metaLine}</Typography>
        </Box>
      </Box>
      <IconButton
        className={classes.removeButton}
        size="small"
        aria-label={`Remove ${displayName}`}
        onClick={() => onRemove(resident)}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

SelectedResidentCard.propTypes = {
  resident: PropTypes.shape({
    personId: PropTypes.number,
    name: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    username: PropTypes.string,
    docId: PropTypes.string,
    location: PropTypes.string,
    facilityName: PropTypes.string,
  }).isRequired,
  onRemove: PropTypes.func.isRequired,
  compact: PropTypes.bool,
};

SelectedResidentCard.defaultProps = {
  compact: false,
};

export default SelectedResidentCard;
